import { userFormSchema, type UserForm } from "@/schemas/user/userFormSchema";
import { formOptions, revalidateLogic } from "@tanstack/react-form";

export const defaultValues: UserForm = {
  firstName: "",
  lastName: "",
  email: "",
  contact1: "",
  contact2: "",
  role: "USER",
  pin: "",
  rank: "",
};

export const adminFormOptions = formOptions({
  defaultValues,
  validators: {
    onSubmit: userFormSchema,
  },
  validationLogic: revalidateLogic({
    mode: "submit",
    modeAfterSubmission: "change",
  }),
});
